import React from "react";

export default function PosSvgIcon(props: React.SVGProps<SVGSVGElement>) {
    const { stopColor, ...svgProps } = props;
    const gradientId = React.useId();
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="115"
            height="115"
            viewBox="0 0 115 115"
            {...svgProps}
        >
            <defs>
                <linearGradient
                    id={gradientId}
                    x1="0.5"
                    x2="0.5"
                    y2="1"
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset="0" stopColor="#3a3a3a" />
                    <stop offset="1" stopColor="#5b5b5b" />
                </linearGradient>
            </defs>
            <g
                id="Groupe_pos"
                data-name="Groupe POS"
                transform="translate(-26 -49)"
            >
                <g
                    id="Groupe_pos_bg"
                    data-name="Groupe POS BG"
                    transform="translate(26 49)"
                >
                    <circle
                        id="Ellipse_pos"
                        data-name="Ellipse POS"
                        cx="57.5"
                        cy="57.5"
                        r="57.5"
                        fill={stopColor}
                    />
                </g>
                <g id="pos-terminal" transform="translate(52 72)">
                    <path
                        id="Tracé_pos_1"
                        data-name="Tracé POS 1"
                        d="M49.5,2H6.5A4.5,4.5,0,0,0,2,6.5v30A4.5,4.5,0,0,0,6.5,41h43A4.5,4.5,0,0,0,54,36.5V6.5A4.5,4.5,0,0,0,49.5,2ZM51,36.5A1.5,1.5,0,0,1,49.5,38H6.5A1.5,1.5,0,0,1,5,36.5V6.5A1.5,1.5,0,0,1,6.5,5h43A1.5,1.5,0,0,1,51,6.5Z"
                        fill={svgProps.fill}
                    />
                    <rect
                        id="Tracé_pos_screen"
                        data-name="Tracé POS Screen"
                        x="9"
                        y="8"
                        width="38"
                        height="20"
                        rx="1.5"
                        fill={svgProps.fill}
                    />
                    <rect
                        id="Tracé_pos_btn1"
                        data-name="Tracé POS Btn1"
                        x="9"
                        y="32"
                        width="8"
                        height="3"
                        rx="1"
                        fill={svgProps.fill}
                    />
                    <rect
                        id="Tracé_pos_btn2"
                        data-name="Tracé POS Btn2"
                        x="21"
                        y="32"
                        width="8"
                        height="3"
                        rx="1"
                        fill={svgProps.fill}
                    />
                    <rect
                        id="Tracé_pos_btn3"
                        data-name="Tracé POS Btn3"
                        x="33"
                        y="32"
                        width="14"
                        height="3"
                        rx="1"
                        fill={svgProps.fill}
                    />
                    <path
                        id="Tracé_pos_2"
                        data-name="Tracé POS 2"
                        d="M4,44h48a2,2,0,0,1,2,2v8a4,4,0,0,1-4,4H6a4,4,0,0,1-4-4V46A2,2,0,0,1,4,44Z"
                        fill={svgProps.fill}
                    />
                    <rect
                        id="Tracé_pos_drawer"
                        data-name="Tracé POS Drawer"
                        x="18"
                        y="49"
                        width="20"
                        height="2.5"
                        rx="1.25"
                        fill={stopColor}
                    />
                </g>
            </g>
        </svg>
    );
}
